import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'mbs-info-card, [mbs-info-card]',
  templateUrl: 'info-card.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: []
})
export class InfoCardComponent {
  public showIcon: InputSignal<boolean> = input<boolean>(true);
}
